export const HIDE_BOARD = 'events/HIDE_BOARD';

/**
 * @param board
 * @return {{type: string, payload: {board, intl, messages}}
 */
export const hideBoard = (board, intl, messages) => ({
  type: HIDE_BOARD,
  payload: { board, intl, messages },
});
